module.exports = {
  RETRIEVE_OUTBOUND_REPORTS_REQUEST: 'RETRIEVE_OUTBOUND_REPORTS_REQUEST',
  RETRIEVE_OUTBOUND_REPORTS_SUCCESS: 'RETRIEVE_OUTBOUND_REPORTS_SUCCESS',
  RETRIEVE_OUTBOUND_REPORTS_FAILURE: 'RETRIEVE_OUTBOUND_REPORTS_FAILURE',
  REPORTS_CHECKED: 'REPORTS_CHECKED',
  SELECT_ALL_REPORTS: 'SELECT_ALL_REPORTS',
  DESELECT_ALL_REPORTS: 'DESELECT_ALL_REPORTS',
};
